import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import config from 'constants/config'
import { OFFER_TYPE_HOTEL } from 'constants/offer'
import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import Group from 'components/utils/Group'
import TermsAndConditionsLink from '../TermsAndConditionsLink'

function ReserveForZeroPolicyModalContent() {
  const intl = useIntl()

  return (
    <Group gap={24} direction="vertical">
      <Group gap={8} direction="vertical">
        <Heading variant="heading6">
          {intl.formatMessage({
            id: 'hI0nQDLzPiP3yr03mVXP',
            defaultMessage: 'Cancellation policy',
            description: 'Heading for reserve for zero cancellation policy section',
          })}
        </Heading>
        <BodyText variant="medium">
          {intl.formatMessage({
            id: 'zoLv1mrIEmAPZjEuVNCR',
            defaultMessage: 'You can cancel your reservation free of charge within 48 hours of submitting your reservation. After that, you will be automatically charged for the booking as per your selected payment plan. Please visit our terms & conditions below to view refund policies.',
            description: 'Body text explaining the reserve for zero cancellation policy',
          })}
        </BodyText>
      </Group>
      <Group gap={8} direction="vertical">
        <Heading variant="heading6">
          {intl.formatMessage({
            id: 'N-7179uLm6kGuAw5Bx1Z',
            defaultMessage: 'Eligibility',
            description: 'Section heading for reserve for zero eligibility section',
          })}
        </Heading>
        <BodyText variant="medium">
          {intl.formatMessage(
            {
              id: 'OT_HwDJDoohidQUqXHk0',
              defaultMessage: 'Currently only available for {productType} hotel deals.',
              description: 'Eligibility description for reserve for zero feature',
            },
            { productType: config.productTypeLabelMap[OFFER_TYPE_HOTEL] },
          )}
        </BodyText>
      </Group>
      <Group gap={8} direction="vertical">
        <Heading variant="heading6">
          {intl.formatMessage({
            id: 'v4mUu4T_jaFOfKJ_h6sS',
            defaultMessage: 'Maximum open reservations',
            description: 'Heading for reserve for zero maximum reservations section',
          })}
        </Heading>
        <BodyText variant="medium">
          {intl.formatMessage({
            id: 'iEPalUnyI3cVyS8rrGMd',
            defaultMessage: 'You can only make 2 reservations at one time.',
            description: 'Maximum reservation limit for reserve for zero feature',
          })}
        </BodyText>
      </Group>
      <Group gap={8} direction="vertical">
        <Heading variant="heading6">
          {intl.formatMessage({
            id: 'ybk-_1idovAl0O6r1ZC9',
            defaultMessage: 'Reservation fee',
            description: 'Heading for reserve for zero reservation fee section',
          })}
        </Heading>
        <BodyText variant="medium">
          {intl.formatMessage({
            id: '2o4VSAAxdt-xOpwPtXaF',
            defaultMessage: 'There is no fee for the 48 hour reservation. After that, any standard booking or service fees applicable to your booking will apply.',
            description: 'Reservation fee explanation for reserve for zero feature',
          })}
        </BodyText>
      </Group>
      <Group gap={8} direction="vertical">
        <Heading variant="heading6">
          {intl.formatMessage({
            id: 'LJ0zJGzwjgXIvyJUklLB',
            defaultMessage: 'Failed payments',
            description: 'Heading for reserve for zero failed payments section',
          })}
        </Heading>
        <BodyText variant="medium">
          {intl.formatMessage({
            id: 'r-zVnOplJAUFuBJSIVET',
            defaultMessage: 'Failure to complete payment will result in the cancellation of your booking.',
            description: 'Failed payment warning for reserve for zero feature',
          })}
        </BodyText>
      </Group>
      <BodyText variant="medium">
        <FormattedMessage
          id="sRY5vw1zEUX3utnSoRLS"
          defaultMessage="{brandName} T&C''s apply - see {termsLink}."
          description="Terms and conditions notice with link for reserve for zero policy"
          values={{
            brandName: config.brandConfig.name,
            termsLink: <TermsAndConditionsLink />,
          }}
        />
      </BodyText>
    </Group>
  )
}

export default ReserveForZeroPolicyModalContent
